import { render, staticRenderFns } from "./FindClue.vue?vue&type=template&id=535443b2&scoped=true&"
import script from "./FindClue.vue?vue&type=script&lang=js&"
export * from "./FindClue.vue?vue&type=script&lang=js&"
import style0 from "./FindClue.vue?vue&type=style&index=0&id=535443b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535443b2",
  null
  
)

export default component.exports